'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRestaurant = function MdRestaurant(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 10c0-3 3.8-6.6 8.4-6.6v33.2h-4.1v-13.2h-4.3v-13.4z m-8.2 5v-11.6h3.2v11.6c0 3.5-2.7 6.4-6.2 6.6v15h-4.1v-15c-3.6-0.2-6.3-3.1-6.3-6.6v-11.6h3.4v11.6h3.2v-11.6h3.4v11.6h3.4z' })
        )
    );
};

exports.default = MdRestaurant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/restaurant.js
// module id = 1128
// module chunks = 0